/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { ArsenalService } from './services/ArsenalService';
import { BuilderService } from './services/BuilderService';
import { DataAnalyticsService } from './services/DataAnalyticsService';
import { FederationService } from './services/FederationService';
import { ForumService } from './services/ForumService';
import { NinthAgeService } from './services/NinthAgeService';
import { PublicationService } from './services/PublicationService';
import { SimulatorService } from './services/SimulatorService';
import { ToolPairingService } from './services/ToolPairingService';
import { TournamentService } from './services/TournamentService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
  public readonly arsenal: ArsenalService;
  public readonly builder: BuilderService;
  public readonly dataAnalytics: DataAnalyticsService;
  public readonly federation: FederationService;
  public readonly forum: ForumService;
  public readonly ninthAge: NinthAgeService;
  public readonly publication: PublicationService;
  public readonly simulator: SimulatorService;
  public readonly toolPairing: ToolPairingService;
  public readonly tournament: TournamentService;
  public readonly user: UserService;
  public readonly request: BaseHttpRequest;
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = FetchHttpRequest,
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'https://www.9thbuilder.com',
      VERSION: config?.VERSION ?? '1',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.arsenal = new ArsenalService(this.request);
    this.builder = new BuilderService(this.request);
    this.dataAnalytics = new DataAnalyticsService(this.request);
    this.federation = new FederationService(this.request);
    this.forum = new ForumService(this.request);
    this.ninthAge = new NinthAgeService(this.request);
    this.publication = new PublicationService(this.request);
    this.simulator = new SimulatorService(this.request);
    this.toolPairing = new ToolPairingService(this.request);
    this.tournament = new TournamentService(this.request);
    this.user = new UserService(this.request);
  }
}
